"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const dayjs_1 = __importDefault(require("dayjs"));
const react_datepicker_1 = require("react-datepicker");
require("dayjs/locale/ru");
const weekday_1 = __importDefault(require("dayjs/plugin/weekday"));
const quarterOfYear_1 = __importDefault(require("dayjs/plugin/quarterOfYear"));
const ru_1 = require("date-fns/locale/ru");
const applicationState_1 = require("src/stores/applicationStore/applicationState");
const sharedUtils_1 = require("src/utils/sharedUtils");
const useLocalStorage_1 = require("src/hooks/useLocalStorage");
const App_1 = __importDefault(require("./App"));
const ErrorBoundary_1 = __importDefault(require("src/components/organisms/ErrorBoundary"));
require("src/styles/application.scss");
const rootNode = document.getElementById("app");
const theme = (0, useLocalStorage_1.useLocalStorage)("theme");
rootNode.classList.add(theme);
const lang = (0, useLocalStorage_1.useLocalStorage)("language");
dayjs_1.default.locale(lang);
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(quarterOfYear_1.default);
(0, react_datepicker_1.registerLocale)("ru", ru_1.ru);
(0, react_datepicker_1.setDefaultLocale)(lang);
if (!(0, sharedUtils_1.isDev)()) {
    // Yandex.Metrika counter
    (function (m, e, t, r, i, k, a) {
        m[i] =
            m[i] ||
                function () {
                    // eslint-disable-next-line prefer-rest-params
                    (m[i].a = m[i].a || []).push(arguments);
                };
        m[i].l = new Date().valueOf();
        for (let j = 0; j < document.scripts.length; j++) {
            if (document.scripts[j].src === r) {
                return;
            }
        }
        (k = e.createElement(t)),
            (a = e.getElementsByTagName(t)[0]),
            (k.async = 1),
            (k.src = r),
            a.parentNode.insertBefore(k, a);
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    ym(92974833, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    });
    // /Yandex.Metrika counter
    // Adopty BEGIN
    (function () {
        function t(t) {
            return function () {
                // eslint-disable-next-line prefer-rest-params
                window["adoptyasync"].push(t, arguments);
            };
        }
        if ("undefined" == typeof window["adopty"]) {
            const n = document.createElement("script");
            (n.type = "text/javascript"),
                (n.async = true),
                (n.src = "https://app.adopty.ru/assets/widgethandle.js"),
                document.getElementsByTagName("head")[0].appendChild(n),
                (window["adopty"] = {}),
                (window["adoptyasync"] = []);
            // eslint-disable-next-line no-var
            for (var e = ["init", "identify", "onReady"], a = 0; a < e.length; a++)
                window["adopty"][e[a]] = t(e[a]);
        }
    })();
    window["adopty"].init("3dfd4aec-9585-4cae-9d43-74767811122e");
    // Adopty END
}
if (rootNode) {
    (0, client_1.createRoot)(rootNode).render((0, jsx_runtime_1.jsx)(ErrorBoundary_1.default, { children: (0, jsx_runtime_1.jsx)(react_redux_1.Provider, Object.assign({ store: applicationState_1.store }, { children: (0, jsx_runtime_1.jsx)(App_1.default, {}) })) }));
}
